var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LoopItemPanel',{attrs:{"title":"Item"}},[_c('div',{staticClass:"shop::canvas-blocks-shop-contentImageTiles-BlockPanel"})])}
var staticRenderFns = []

export { render, staticRenderFns }